<template>
  <div>
    <h1 class="title">Este es el modulo para borrar registros</h1>
    <y-periodselector @period="periodselected" :iscierre="true" :period="period"></y-periodselector>
    <button class="button is-link" @click="consultar">Consultar</button>
    <button class="button is-danger" @click="borrar">Borrar</button>
    <hr />
    <div class="notification is-link">
      <button class="delete"></button>
      {{message}}
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
export default {
  data() {
    return {
      period: {
        year: null,
        months: null,
      },
      message:
        "Si consulta el dato aparecera cuantos registros tiene, y si borra borrara los registros del periodos seleccionado.",
    };
  },
  methods: {
    periodselected(period) {
      this.period = period;
    },
    async consultar() {
      try {
        const result = await apiServices.post(`/countregistros`, this.period);
        this.message = `El periodo ${this.period.months[0]} - ${this.period.year}. Tiene ${result.data} registros contables.`;
        this.count = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    async borrar() {
      try {
        const result = await apiServices.post(`/deleteregisters`, this.period);
        this.message = `Se borraron ${result.data.deletedCount} registros del periodo ${this.period.months[0]} - ${this.period.year}`;
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
  },
  components: {
    yPeriodselector,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/registros/DeleteRegisters.vue